/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import {
  Button
} from '@insticator/insticator-ui'; // iui-material
// styles


const ActionButtons = (props) => {
  const {
    handleCancel,
    handleSave,
    disableSave,
    isOpened,
    setIsOpened,
    processing
  } = props;

  return (
      <>
          <Button
              variant={'system'}
              text={'Cancel'}
              type={'action'}
              action={() => {
                  handleCancel();
                  setIsOpened(false)
              }}
          />
          <Button
              variant={'primary'}
              text={'Save & Close'}
              type={'action'}
              disabled={disableSave}
              processing={processing}
              action={() => {
                  handleSave();
                  setIsOpened(isOpened)
              }}
          />
      </>
  )
};

export default ActionButtons
